<!-- header section -->
<app-header></app-header>
<section class="login-module">
  <div class="container my-5">
    <div class="login-banner inner-banner d-flex align-items-center bg-primary">
      <h1>{{pageName|titlecase}}</h1>
    </div>
  </div>
  <div class="container login-container">
    <div class="row">
      <div class="col-lg-4 left-sec pe-lg-0 d-none d-lg-block">
        <div class="h-100 inner-box">
          <div class="top-box px-4 pt-4 bg-primary text-center">
            <img [src]="'assets/images/login/login-dog.png'" alt="" class="img-fluid">
          </div>
          <div class="bottom-box p-5">
            <ul>
              <li>
                <strong class="d-block">Wish to Board My Pet</strong>
                Yes we are having boarding service for your lovable pet.
              </li>
              <li>
                <strong class="d-block">Wish to Opt for Wellness Plans</strong>
                Our awesome wellness plans and our extra add-ons will make your requirement complete.
              </li>
              <li>
                <strong class="d-block">Wish to Groom My Pet</strong>
                Our experienced Groomers will change the complete look of your pet.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-8 right-sec ps-lg-0 mb-5 mb-lg-0">
        <div class="form-box h-100 d-flex justify-content-center align-items-center p-5">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- login page middle content start here -->

<!-- footer section -->
<app-footer></app-footer>